// extracted by css-extract-rspack-plugin
export default {"tab":"tab-2O4sC"};